import { render } from "./SecuritiesSecurities.vue?vue&type=template&id=75641d92&scoped=true&ts=true"
import script from "./SecuritiesSecurities.vue?vue&type=script&lang=ts"
export * from "./SecuritiesSecurities.vue?vue&type=script&lang=ts"

import "./SecuritiesSecurities.vue?vue&type=style&index=0&id=75641d92&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75641d92"]])

export default __exports__